<template>
  <div id="app">
    <Headbar />
    <div
      id="adsgoeshere"
      style="width:380px;height:60px;text-align: center;"
      v-html="adsenseContent"
      align="center"
    ></div>
    <Menubar />
    <router-view></router-view>
    <Footbar />
    <back-to-top bottom="30px" right="30px">
      <el-button icon="el-icon-caret-top" circle></el-button>
    </back-to-top>
  </div>
</template>

<script>
import Headbar from './components/header.vue'
import Menubar from './components/menubar.vue'
import Footbar from './components/footer.vue'
export default {
  name: 'App',
  components: { Headbar, Menubar, Footbar },
  data () {
    return { adsenseContent: '' }
  },
  mounted: function () {
    this.adsenseContent = document.getElementById('divadsensedisplaynone').innerHTML
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue